import {Component, Input} from '@angular/core';

import { Denuncia } from '../denuncia/denuncia';
import { DenunciaService } from '../denuncia/denuncia.service';

import { Incidente } from '../incidente/incidente';
import { IncidenteService } from '../incidente/incidente.service';
import { Classificacao } from '../incidente/classificacao';

import { Router, ActivatedRoute, Params } from '@angular/router';


@Component({
  selector: 'app-modal-resumo',
  template: `
  <div id="modalr" (click)="onContainerClicked($event)" class="modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
       [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal();">&times;</button>
        <h4 class="modal-title">Resumo do caso</h4>
          <ng-content select=".app-modal-header"></ng-content>
        </div>
        <form id="login-form">
        <div class="modal-body">
            <label for="selectDescricao">Descrição:</label>
            <textarea class="form-control" rows="3" id="inputDescricao" name="resumoCaso" [(ngModel)]="resumo" placeholder="Descreva o resumo do caso"></textarea>
            <br />
            <label for="selectClassificacao">Classificação</label>
            <p class="help-block">Marque todos que considerar pertinente</p>
            <div class="checkbox" *ngFor="let classificacao of classificacoes">
              <label class="col-md-6 col-sm-12">
              <input type="checkbox" checked="{{ this.listaItens && -1 !== this.listaItens.indexOf(classificacao.nome) ? 'checked' : '' }}"  (change)="selClassificacao(classificacao.id,$event)">{{classificacao.nome}}
              </label>
            </div>
			<div class="checkbox">
				<label class="col-md-6 col-sm-12">
					<input type="checkbox" name="classificacao" value="0" [checked]="outraClass" (click)="subOutraClassificacao()">Outros
				</label>
			</div>
            <div *ngIf="outraClassificacao" class="col-md-6 col-sm-12 col-md-offset-6">
              <div class="form-group">
                <label for="inputOutraClassificacao">Outra classificação</label>
                <input type="text" class="form-control" id="inputOutraClassificacao" placeholder="Descreva a outra classificação" name="outraClassif" [(ngModel)]="outraClass">
              </div>
            </div>
          <ng-content select=".app-modal-body"></ng-content>
        </div>
        <div class="modal-footer">
            <div class="col-sm-offset-2 col-sm-10">
            <button type="button" class="btn btn-default" (click)="closeModal();">Fechar</button>
            <button class="btn btn-default" (click)="salvarResumoCaso();" data-dismiss="modalr">Salvar</button>
            <button class="btn btn-success" (click)="enviarIncidente();" data-dismiss="modalr">Salvar e Enviar</button>
            </div>
          <ng-content select=".app-modal-footer"></ng-content>
        </div>
        </form>
      </div>
    </div>
  </div>
  `,
  styles: [`
    .modal {
      background: rgba(0,0,0,0.6);
    }
	.modal-body {
		max-height: 400px;
		overflow: auto;
	}
	.modal-dialog {
		width: 90%;
	}
  `],
  providers: [
    DenunciaService,
    IncidenteService
  ]
})
export class ModalResumoComponent {

  public visible = false;
  private visibleAnimate = false;

  denuncia: Denuncia;

  incidente: Incidente;

  classificacoes: Classificacao[];

  itensClassificacao = [];

  outraClassificacao: boolean;

  resumo: string;
  outraClass: string;
  listaItens: string;

  @Input() resumoCaso:string;
  @Input() outraClassif: string;
  @Input() idInc: number;

  constructor(private denService: DenunciaService, private incidenteService: IncidenteService, private router: Router){
  }

  selClassificacao(value,event){
    if (event.target.checked) {
      this.itensClassificacao.push(value);
    }
    else if (!event.target.checked) {
      let indexx = this.itensClassificacao.indexOf(value);
      this.itensClassificacao.splice(indexx,1);
    }
    //console.log("CHECKBOX CLASSIF ");
    //console.log(this.itensClassificacao);
  }

  subOutraClassificacao() {
    this.outraClassificacao = !this.outraClassificacao;
    this.outraClass = '';
  }

  public show(id): void {
    this.outraClassificacao = false;
    //console.log(id);

    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);

    this.idInc = id;
    this.incidenteService.getClassificacao()
    .then((classificacao) => this.classificacoes = classificacao);

    this.incidenteService.getDadosIncidente(id)
    .then((incidente) => {this.resumo = incidente.resumoCaso;
      if (incidente.classificacao !== null) {
        this.outraClass = incidente.classificacao;
        this.outraClassificacao = true;
      }
      else {
        this.outraClass = '';
        this.outraClassificacao = false;
      }
      this.itensClassificacao = incidente.classificacoes;
      this.listaItens = incidente.listaclassif;
      this.incidente = incidente;

   });

  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public closeModal(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  public salvarResumoCaso(): void {
    this.incidente = new Incidente;

    // definindo o id do incidente, o resumo do caso e a classificacao
    this.incidente.id = this.idInc;
    this.incidente.resumoCaso = this.resumo;
    this.incidente.itensClassificacaoFinal = this.itensClassificacao;
    this.incidente.classificacao = this.outraClass;
    this.incidente.enviado = false;
    this.incidente.encaminhado = false;
    this.incidente.flagPsicologico = false;
    //console.log(this.incidente);

    this.incidenteService.salvarResumoCaso(this.incidente)
        .then((resposta) => this.goBack(resposta))

    // fecha a janela modal
    this.hide();

  }

  public enviarIncidente(): void {
    this.incidente = new Incidente;

    // definindo o id do incidente, o resumo do caso e a classificacao
    this.incidente.id = this.idInc;
    this.incidente.resumoCaso = this.resumo;
    this.incidente.itensClassificacaoFinal = this.itensClassificacao;
    this.incidente.classificacao = this.outraClass;
    //console.log(this.incidente);
    this.incidente.enviado = true;
    this.incidente.encaminhado = false;

    this.incidenteService.enviarIncidente(this.incidente)
        .then((resposta) => this.goBack(resposta))

    // fecha a janela modal
    this.hide();

  }

  goBack(resposta: any): void {
     alert(resposta);
     window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/denuncias/modalresumo.component.ts